export enum OrderType {
  // POPULAR = 'id|desc',
  POPULAR = 'special|sorting',
  BEST_SELLER = 'sku|desc',
  HIGH_PRICE = 'price|desc',
  LOW_PRICE = 'price|asc',
}

export const PAGE_SIZE = 48;
